import { defineStore } from "pinia";
import { ref } from "vue";

type Options = {
    title: string;
    message: string;
    agreeButtonText: string;
    agreeButtonColor?: string;
    agreeButtonVariant?:
        | "default"
        | "destructive"
        | "outline"
        | "secondary"
        | "ghost"
        | "link"
        | "icon";
    width?: number;
    zIndex?: number;
    cancellable?: boolean;
};

export const useDialogStore = defineStore("dialog", () => {
    const open = ref(false);
    const cancellable = ref(true);
    const title = ref("");
    const message = ref("");
    const agreeButtonText = ref("");
    const agreeButtonColor = ref("");
    const agreeButtonVariant = ref("");
    const width = ref(400);
    const zIndex = ref(1004);
    const resolve = ref();
    const reject = ref();

    function confirm(options: Options) {
        title.value = options.title;
        message.value = options.message;
        agreeButtonText.value = options.agreeButtonText;
        if (options.cancellable !== undefined) {
            cancellable.value = options.cancellable;
        }

        if (options.agreeButtonColor) {
            agreeButtonColor.value = options.agreeButtonColor;
        }

        if (options.agreeButtonVariant) {
            agreeButtonVariant.value = options.agreeButtonVariant;
        }

        if (options.width) {
            width.value = options.width;
        }

        if (options.zIndex) {
            zIndex.value = options.zIndex;
        }

        open.value = true;

        return new Promise((res, rej) => {
            resolve.value = res;
            reject.value = rej;
        });
    }

    function agree() {
        resolve.value();
        open.value = false;
    }

    function cancel() {
        reject.value();
        open.value = false;
    }

    return {
        open,
        cancellable,
        title,
        message,
        agreeButtonText,
        agreeButtonColor,
        agreeButtonVariant,
        width,
        zIndex,
        confirm,
        agree,
        cancel,
    };
});
